import { LOGIN_URL } from './domains';

const TOKEN_KEY = 'User-Token';
let loginPrompting = false;

function readCookie(name) {
  const key = `${encodeURIComponent(name)}=`;
  const parts = document.cookie ? document.cookie.split('; ') : [];
  for (const part of parts) {
    if (part.startsWith(key)) {
      return decodeURIComponent(part.slice(key.length));
    }
  }
  return '';
}

export function getToken() {
  // 改为 cookie 识别：要求当前站点可读到同顶级域下写入的该 cookie。
  return readCookie(TOKEN_KEY);
}

export function hasLogin() {
  return !!getToken();
}

export function getAuthorizationHeader() {
  return {};
}

export function promptLogin(message = '当前未登录或登录已失效，是否前往登录页？') {
  if (loginPrompting) return;
  loginPrompting = true;
  try {
    const ok = window.confirm(message);
    if (ok) {
      window.location.href = LOGIN_URL;
    }
  } finally {
    loginPrompting = false;
  }
}
